var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgm1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9612_27920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4842C0 11.2808 0.97555 10.3053 2.17895 10.3053H6.53686C7.74026 10.3053 8.71581 11.2808 8.71581 12.4842V18.0526C8.71581 18.4538 8.39062 18.779 7.98949 18.779H0.726317C0.325183 18.779 0 18.4538 0 18.0526V12.4842Z",
    fill: "#0B97D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2843 12.4842C14.2843 11.2808 15.2599 10.3053 16.4633 10.3053H20.8212C22.0246 10.3053 23.0001 11.2808 23.0001 12.4842V18.0526C23.0001 18.4538 22.6749 18.779 22.2738 18.779H15.0106C14.6095 18.779 14.2843 18.4538 14.2843 18.0526V12.4842Z",
    fill: "#CFE9F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.35782,
    cy: 7.6421,
    r: 3.14738,
    fill: "#0B97D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.6421,
    cy: 7.6421,
    r: 3.14738,
    fill: "#CFE9F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77893 13.2105C6.77893 12.0071 7.75448 11.0316 8.95788 11.0316H13.3158C14.5192 11.0316 15.4947 12.0071 15.4947 13.2105V18.779C15.4947 19.1801 15.1696 19.5053 14.7684 19.5053H7.50525C7.10411 19.5053 6.77893 19.1801 6.77893 18.779V13.2105Z",
    fill: "#1A3763"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1369,
    cy: 8.36843,
    r: 3.14738,
    fill: "#1A3763"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9612_27920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5896 13.6947H12.3474V13.2105C12.3474 12.5423 11.8051 12 11.1369 12C10.4687 12 9.92639 12.5423 9.92639 13.2105V13.6947H9.68428C9.41797 13.6947 9.20007 13.9126 9.20007 14.179V16.6C9.20007 16.8663 9.41797 17.0842 9.68428 17.0842H12.5896C12.8559 17.0842 13.0738 16.8663 13.0738 16.6V14.179C13.0738 13.9126 12.8559 13.6947 12.5896 13.6947ZM10.4106 13.2105C10.4106 12.8086 10.735 12.4842 11.1369 12.4842C11.5388 12.4842 11.8632 12.8086 11.8632 13.2105V13.6947H10.4106V13.2105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1369,
    cy: 15.1474,
    r: 0.484212,
    fill: "#1A3763"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.8947,
    y: 15.3895,
    width: 0.484212,
    height: 0.968423,
    fill: "#1A3763"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9612_27920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9612_27920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.81054,
    height: 5.81054,
    fill: "white",
    transform: "translate(8.23157 11.7579)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgm1);
export default __webpack_public_path__ + "static/media/agm_1.d6dfe011d68e4249aeda030fc0575118.svg";
export { ForwardRef as ReactComponent };